import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  signal,
} from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { firstValueFrom, map } from 'rxjs';
import { OrdenesService } from '../../utilidades/ordenes.service';
import { CONFIGURACION_FICHA_VER_ORDEN } from './utilidades/ver-orden.static';
import { deepCopy } from 'src/app/compartido/utilidades/objetos.utils';
import { Orden } from '../../utilidades/orden.class';
import { valorNumérico } from 'src/app/compartido/utilidades/valores.utils';
import { ConfiguracionFicha } from 'src/app/compartido/ficha/utilidades/ficha.models';
import { AlertasService } from 'src/app/nucleo/utilidades/alertas.service';
import { ErrorFrontend } from 'src/app/compartido/utilidades/error.utils';
import { Permiso } from 'src/app/nucleo/autorizacion/autorizacion.models';

@Component({
  selector: 'ordenes-ver-orden',
  templateUrl: './ver-orden.component.html',
  styleUrls: ['./ver-orden.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class VerOrdenComponent implements OnInit {
  /* Configuración de la ficha */
  protected configFicha: ConfiguracionFicha = CONFIGURACION_FICHA_VER_ORDEN;

  /* ID de la orden */
  @Input() idOrden: number | undefined;

  /* Orden */
  protected orden: Orden | undefined;

  /* Estado de carga */
  protected cargando = signal<boolean>(true);

  /* Constantes */
  protected readonly Permiso = Permiso;

  constructor(
    private readonly _ordenesService: OrdenesService,
    private readonly _alertasService: AlertasService,
    private readonly _cdr: ChangeDetectorRef,
    private readonly _route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this._obtenerOrden$();
  }

  /**
   * Obtiene la orden.
   * @author Juan Corral
   */
  private async _obtenerOrden$(): Promise<void> {
    this.cargando.set(true);

    // Obtener el ID de la orden
    const param = await firstValueFrom<string>(
      this._route.params.pipe(map((params: Params) => params['id'])),
    );
    if (!this.idOrden) this.idOrden = valorNumérico(param)!;

    // Validar el ID de la orden
    if (!this.idOrden) {
      this._alertasService.alertarError('ID de la orden no válido');
      this.cargando.set(false);
      return;
    }

    // Obtener la orden
    this.orden = await this._ordenesService
      .obtenerOrden$(this.idOrden)
      .catch((error: ErrorFrontend) => {
        this._alertasService.alertarError('Error: ' + error.message);
        return undefined;
      });

    // Validar la orden
    if (!this.orden) this._alertasService.alertarError('Orden no encontrada');
    else {
      const ficha = deepCopy(this.configFicha);
      ficha.header!.titulo = `Orden: ${this.orden.titulo}`;
      this.configFicha = ficha;
    }

    this.cargando.set(false);
    this._cdr.markForCheck();
  }
}
